import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';

import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { IdentityProviderConfigService } from '../identity-provider-config.service';

@Component({
  templateUrl: './delete-dialog.component.html',
  standalone: false,
})
export class DeleteDialogComponent {
  loading$$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  deleting$$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  businessCenterName$: Observable<string>;

  constructor(
    public dialogRef: MatDialogRef<DeleteDialogComponent>,
    private idpConfigService: IdentityProviderConfigService,
    private snackbarService: SnackbarService,
  ) {}

  delete(): void {
    this.deleting$$.next(true);
    this.idpConfigService.deleteConfig().subscribe(
      () => this.dialogRef.close(true),
      () => {
        this.deleting$$.next(false);
        this.snackbarService.errorSnack('Sorry, something went wrong.');
      },
    );
  }
}
